import Repository from './Repository';

export default class TicketTimeRepository extends Repository {
    protected basePath = 'tickets/time';

    public destroy(id: string, data: object = null): Promise {
        console.error('Destroy method does not exist on TicketTimeRepository.');
    }

    public import(data: object): Promise {
        console.error('Import method does not exist on TicketTimeRepository.');
    }

    public show(id: string, params: object = null): Promise {
        console.error('Show method does not exist on TicketTimeRepository.');
    }

    public store(data: object, params: object = null) {
        console.error('Store method does not exist on TicketTimeRepository.');
    }

    public update(id: string, data: object, params: object = null) {
        console.error('Update method does not exist on TicketTimeRepository.');
    }
}